import { RootStoreState } from 'modules/root'

export const selectParticipation = (state: RootStoreState) => state.participant.participation
export const selectParticipations = (state: RootStoreState) => state.participant.participations
export const selectSurvey = (state: RootStoreState) => state.participant.survey
